 // src/components/Projects.js
import React from 'react';
import ProjectCard from './ProjectCard';


const Projects = () => {
  const projectData = [
    { title: 'Omnifood', imgSrc: 'omnifood.jpg', link: 'https://omnifood.netlify.app' },
    { tittle: 'ecommerce', imgSrc:'https://th.bing.com/th?id=OIP.Gsy3Ou9iT68EDXt5CM525wHaHa&w=250&h=250&c=8&rs=1&qlt=90&o=6&pid=3.1&rm=2', link:'https://sheddygadgets.netlify.app/ ' },
    { title: 'Analysis', imgSrc: 'newyoutube.jpg', link: 'https://access24.netlify.app' },
    { title: 'consulting', imgSrc: 'sodacomesite.jpg', link: 'https://sodacomsite.netlify.app' },
    { title: 'realtor', imgSrc: 'reator.jpg', link: 'https://realtor24.netlify.app' },
    { title: 'crypto', imgSrc: 'crypto.jpg', link: 'https://dapps25.netlify.app' },
    { title: 'MarcoBerry', imgSrc: 'marcoberry.jpg', link: 'https://marcoberry.netlify.app' },
    { title: 'PizzaCart24', imgSrc: 'pizzacart.jpg', link: 'https://pizzacart24.netlify.app' },
    { title: 'MarcoQuiza', imgSrc: 'quiza.jpg', link: 'https://marcoquiza.netlify.app' },
    { title: 'Todo', imgSrc: 'https://th.bing.com/th?id=OIP.Tai24BuXPmuSiOsItwzedgHaFj&w=288&h=216&c=8&rs=1&qlt=90&o=6&pid=3.1&rm=2', link: 'https://merakiacdemi23.netlify.app/' },
    { title: 'ShopyCart', imgSrc: 'shopycart.jpg', link: 'https://shopycart24.netlify.app' },
    { title: 'ImageSlider', imgSrc: 'image.jpg', link: 'https://imageslider24.netlify.app' },
    { title: 'RedoTodo', imgSrc: 'todo.jpg', link: 'https://redotodo.netlify.app' },
     
  ];

  return (
    <section id="projects" className="projects-section">
      <h2>My Projects</h2>
      <div className="projects-grid">
        {projectData.map((project, index) => (
          <ProjectCard key={index} title={project.title} imgSrc={project.imgSrc} link={project.link} />
        ))}
      </div>
    </section>
  );
};

export default Projects;
